import { render, staticRenderFns } from "./VuesticTooltip.vue?vue&type=template&id=2c8861a8&scoped=true"
import script from "./VuesticTooltip.vue?vue&type=script&lang=js"
export * from "./VuesticTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8861a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c8861a8')) {
      api.createRecord('2c8861a8', component.options)
    } else {
      api.reload('2c8861a8', component.options)
    }
    module.hot.accept("./VuesticTooltip.vue?vue&type=template&id=2c8861a8&scoped=true", function () {
      api.rerender('2c8861a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-tooltip/VuesticTooltip.vue"
export default component.exports